/// Where to go back to after signing in: a path on this site ("/contact?topic=order" - the contact page sends a
/// shopper to sign in before they write about an order), else the home page. Never "//host", and never a backslash,
/// which browsers read as a slash: nothing here can send anyone off the site.
export function safeReturnUrl(url: string | null | undefined): string {
    const text = String(url || '');
    return /^\/(?![\/\\])/.test(text) && !/[\s\\]/.test(text) ? text : '/';
}
